/**
 * Legacy profiles stored social-media handles, while newly created profiles
 * store complete account URLs. Keep the two formats distinguishable when
 * rendering the historical profile data.
 */
export const HTTP_URL_PATTERN = /^https?:\/\/\S+$/i;

export const isHttpUrl = (value: unknown): value is string =>
  typeof value === 'string' && HTTP_URL_PATTERN.test(value.trim());
